import {VideoEditor} from "./component/video-editor/video-editor";
import {Cover} from "../../entity";
import {MouseEvent, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {State} from "../../state";
import {useTranslation} from "react-i18next";
import {PHOTO_EDITOR_ACTIONS} from "../../action/photos/photos.constants";
import {getWarranty, uploadPhotosData} from "../../action";
import {useNavigate, useParams} from "react-router-dom";
import './video-editor.page.scss';
import {MessageModal} from "../../component/modal";

interface VideoEditorPageProps {}

export const VideoEditorPage = (props: VideoEditorPageProps) => {
    const { videoId } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const [actualCover, setActualCover] = useState<Cover | null>(null)
    const { acceptCover, isToolsEnabled } = useSelector((state: State) => state.editor)
    const { warranty } = useSelector((state: State) => state.warranty)

    const { loadingStarted } = useSelector((state: State) => state.editor)
    const { inProgress } = useSelector((state: State) => state.base)

    const onCancelCallback = () => {
        dispatch({ type: PHOTO_EDITOR_ACTIONS.CLEAR })
    }

    const onAcceptCallback = async () => {
        await uploadPhotosData(warranty!.id)
    }

    const onCancelButtonClick = async (event: MouseEvent) => {
        event.preventDefault()
        if (!isToolsEnabled) {
            if (acceptCover != null) {
                console.log(`all`)
                onDeleteAllCovers()
            } else {
                console.log(`cancell`)
                onCancelCallback()
                navigate(`/warranty/${ warranty!.id }`)
            }
        } else {
            console.log(`remove last`)
            onRemoverLastCover()
        }

    }

    const onAcceptButtonClick = async (event: MouseEvent) => {
        event.preventDefault()

        {
            !isToolsEnabled ? await onAcceptCallback() : await onAcceptCover()
        }
    }

    const onAcceptCover = async () => {
        if (actualCover != null) {
            dispatch({ type: PHOTO_EDITOR_ACTIONS.ADD_COVER, cover: actualCover, from: 0.001 })
        }

        dispatch({ type: PHOTO_EDITOR_ACTIONS.SELECTED_TOOL, tool: null })
        dispatch({ type: PHOTO_EDITOR_ACTIONS.IS_TOOLS_ENABLED, enabled: false })
        dispatch({ type: PHOTO_EDITOR_ACTIONS.ACCEPT_COVER, acceptCover: false })

        setActualCover(null)

        await getWarranty(warranty!.id)
    }

    const onRemoverLastCover = () => {
        // dispatch({ type: PHOTO_EDITOR_ACTIONS.REMOVE_COVER })
        dispatch({ type: PHOTO_EDITOR_ACTIONS.ACCEPT_COVER, acceptCover: false })
        dispatch({ type: PHOTO_EDITOR_ACTIONS.SELECTED_TOOL, tool: null })
        dispatch({ type: PHOTO_EDITOR_ACTIONS.IS_TOOLS_ENABLED, enabled: false })

        setActualCover(null)
    }

    const onDeleteAllCovers = () => {
        dispatch({ type: PHOTO_EDITOR_ACTIONS.DELETE_ALL_COVER })
        dispatch({ type: PHOTO_EDITOR_ACTIONS.SELECTED_TOOL, tool: null })
        dispatch({ type: PHOTO_EDITOR_ACTIONS.IS_TOOLS_ENABLED, enabled: false })
        dispatch({ type: PHOTO_EDITOR_ACTIONS.ACCEPT_COVER, acceptCover: null })

        setActualCover(null)
    }


    if (warranty === null) {
        return <></>
    }

    const mediaFile = warranty.mediaFiles!.find(mediaFile => mediaFile.id === Number(videoId));

    if (!mediaFile) {
        return <></>
    }

    return (
        <main className="page page-video-editor">
            <VideoEditor mediaFile={ mediaFile } editable={ true } onDrawEnd={(cover: Cover) => {
                setActualCover(cover)
                //dispatch({ type: PHOTO_EDITOR_ACTIONS.ADD_COVER, cover: cover })
            }} />

            <div className={`edit-photo-modal__buttons`}>

                <button className="button" onClick={onCancelButtonClick}>
                    {isToolsEnabled ? t('edit_photo_modal_delete_cover_button') : acceptCover != null ? t('edit_photo_modal_delete_all_cover_button') : t('button_cancel')}
                </button>

                <button className="button" onClick={onAcceptButtonClick}>
                    {isToolsEnabled ? t('edit_photo_modal_place_cover_button') : acceptCover != null ? t(mediaFile.type === 0 ? 'edit_photo_modal_accept_photo_button' : 'edit_video_modal_accept_video_button') : t('edit_photo_modal_accept_covering_button')}
                </button>
            </div>

            {loadingStarted === null ? (
                <MessageModal
                    title={t('save_photo_modal_title')}
                    message={''}
                    onCloseClick={() => {
                        dispatch({ type: PHOTO_EDITOR_ACTIONS.CLEAR })
                        navigate(`/warranty/${ warranty!.id }`)
                    }}
                    onOkClick={async () => {
                        dispatch({ type: PHOTO_EDITOR_ACTIONS.CLEAR })
                        navigate(`/warranty/${ warranty!.id }`)
                    }}
                />
            ) : null}

            { inProgress && <div className="progress-layer">
                <svg fill="#FFFFFF" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width={128}>
                    <g>
                        <circle cx="12" cy="2.5" r="1.5" opacity=".14"/>
                        <circle cx="16.75" cy="3.77" r="1.5" opacity=".29"/>
                        <circle cx="20.23" cy="7.25" r="1.5" opacity=".43"/>
                        <circle cx="21.50" cy="12.00" r="1.5" opacity=".57"/>
                        <circle cx="20.23" cy="16.75" r="1.5" opacity=".71"/>
                        <circle cx="16.75" cy="20.23" r="1.5" opacity=".86"/>
                        <circle cx="12" cy="21.5" r="1.5"/>
                        <animateTransform attributeName="transform" type="rotate" calcMode="discrete" dur="0.75s" values="0 12 12;30 12 12;60 12 12;90 12 12;120 12 12;150 12 12;180 12 12;210 12 12;240 12 12;270 12 12;300 12 12;330 12 12;360 12 12" repeatCount="indefinite"/>
                    </g>
                </svg>
            </div> }
        </main>
    )
}